import { DocumentSource } from '@insurance/api/requests'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const sourceList = [
  ...Object.values(DocumentSource).filter(
    (value) => ![DocumentSource.IOS, DocumentSource.ANDROID].includes(value)
  ),
  'mobile'
]

export const sourceOptions = (t: TFunction): SelectProps['options'] =>
  sourceList.map((value) => ({
    label: t(`source_${value}`),
    value
  }))
